import { UserType } from '../user';
export * as Api from './api';
import { Realm } from '../global';

export enum AuthGateDecision {
  ChooseAccount = 'choose-account',
  CopyProfile = 'copy-profile',
}

export enum InvestorAccessPermission {
  EditAll = 'edit:all',
  CreateAll = 'create:all',
  ReadAll = 'read:all',
  SignDocuments = 'sign:documents',
}

export enum EisInvestorAccessPermissionGroupKey {
  Full = 'Full',
  ReadOnly = 'ReadOnly',
}

export const EisInvestorAccessPermissionGroup: Record<
  EisInvestorAccessPermissionGroupKey,
  Array<InvestorAccessPermission>
> = {
  [EisInvestorAccessPermissionGroupKey.Full]: [
    InvestorAccessPermission.EditAll,
    InvestorAccessPermission.CreateAll,
    InvestorAccessPermission.ReadAll,
  ],
  [EisInvestorAccessPermissionGroupKey.ReadOnly]: [
    InvestorAccessPermission.ReadAll,
  ],
};

export enum LpInvestorAccessPermissionGroupKey {
  Full = 'Full',
  ReadOnly = 'ReadOnly',
  FullExceptSigning = 'FullExceptSigning',
}

export const LpInvestorAccessPermissionGroup: Record<
  LpInvestorAccessPermissionGroupKey,
  Array<InvestorAccessPermission>
> = {
  [LpInvestorAccessPermissionGroupKey.Full]: [
    InvestorAccessPermission.EditAll,
    InvestorAccessPermission.CreateAll,
    InvestorAccessPermission.ReadAll,
    InvestorAccessPermission.SignDocuments,
  ],
  [LpInvestorAccessPermissionGroupKey.FullExceptSigning]: [
    InvestorAccessPermission.EditAll,
    InvestorAccessPermission.CreateAll,
    InvestorAccessPermission.ReadAll,
  ],
  [LpInvestorAccessPermissionGroupKey.ReadOnly]: [
    InvestorAccessPermission.ReadAll,
  ],
};

export interface FurtherUserTokenPayload {
  _id: string;
  email: string;
  activeUserType: UserType | undefined;
  activeAccountIds: Array<string>;
  investorAccessPermissions?: Array<InvestorAccessPermission>;
  isAdminUserImpersonatingFurtherUser?: boolean;
  restrictToFirmId?: string;
  investorRealm?: Realm;
}

export enum FurtherUserErrorCode {
  ImpersonationFirmMismatch = 'IMPERSONATION_FIRM_MISMATCH',
}
export interface EncryptedHash {
  iv: string;
  content: string;
}
